export default __webpack_public_path__ + "static/media/airfield.e34a3393.jpg";